module.exports = __webpack_public_path__ + "3942b20ff0548a966a0311f7998ae182.jpg";